import { Seo } from '@/shared/seo/Seo'
import { Section, SectionHeader } from '@/shared/ui/Section'
import { Prose } from '@/shared/ui/Prose'
import { site } from '@/content/site'

/**
 * TODO: legal review required before launch. These are website terms only —
 * they are not the terms of any engagement, which belong in a signed contract.
 */
export function Component() {
  return (
    <>
      <Seo
        title="Terms of service"
        description="The terms governing use of the Softife website, covering acceptable use, intellectual property, and the limits of the information published here."
        path="/terms"
      />

      <Section size="lg">
        <SectionHeader as="h1" title="Terms of service" />
        <Prose className="mt-8">
          <p>
            <strong>TODO: legal review required before launch.</strong> These terms cover use of
            this website only. They do not govern any engagement between {site.name} and a client,
            which is set out in a separate signed agreement.
          </p>

          <h2>Use of this site</h2>
          <p>
            You may use this website for lawful purposes. You may not attempt to disrupt it, gain
            unauthorised access to it, or use automated means to submit the contact form.
          </p>

          <h2>Content and intellectual property</h2>
          <p>
            The content on this site — text, design, and code — belongs to {site.name} unless stated
            otherwise. Client names and marks shown in case studies remain the property of their
            respective owners and appear with permission.
          </p>

          <h2>Accuracy</h2>
          <p>
            We keep this site accurate and current, but it describes services in general terms.
            Nothing on it constitutes a binding offer, a fixed price, or professional advice for
            your specific situation.
          </p>

          <h2>Liability</h2>
          <p>
            TODO: liability wording must be drafted or reviewed by a qualified professional for the
            relevant jurisdiction rather than adapted from a template.
          </p>

          <h2>Governing law</h2>
          <p>TODO: state the governing jurisdiction.</p>
        </Prose>
      </Section>
    </>
  )
}

Component.displayName = 'TermsPage'
